import React, { useEffect, useState } from "react";
import { Alert, Grid, Stack, Typography } from "@mui/material";

import StatBox from "../../../shared-components/StatBox";

const labels = {
  discovered: "contacts suggested",
  verified: "contacts verified",
  enrolled: "contacts ever enrolled",
  sent: "emails sent",
  suppressed: "suppressed contacts",
  converted: "contacts converted",
  distinctSchools: "distinct schools",
  failedEnrichment: "failed enrichment attempts",
};
const descriptions = {
  discovered:
    "Unique outreach contacts saved so far, including those not yet verified.",
  verified: "Contacts whose email is publicly confirmed or provider verified.",
  enrolled:
    "Unique contacts who have joined an outreach workflow, including finished or stopped journeys.",
  sent: "Outreach emails sent across all journeys. A contact may receive more than one.",
  suppressed:
    "Contacts currently blocked from outreach, for example after unsubscribing.",
  converted:
    "Outreach contacts linked to a newly created Fruitify account by matching email.",
  distinctSchools:
    "Schools with at least one publicly confirmed or provider-verified contact. Each school is counted once.",
  failedEnrichment:
    "School searches that could not complete because of an error.",
};
export default function OutreachMetrics({ api }) {
  const [metrics, setMetrics] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setError("");
    api
      .getOutreachMetrics()
      .then((data) => {
        if (active) setMetrics(data);
      })
      .catch((failure) => {
        if (active) setError(failure.message);
      });
    return () => {
      active = false;
    };
  }, [api]);
  return (
    <Stack spacing={1}>
      <Typography variant="h6">Outreach summary</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {metrics && (
        <Grid container spacing={2}>
          {Object.entries(labels).map(([key, label]) => (
            <Grid key={key} size={{ xs: 12, sm: 6, lg: 3 }}>
              <StatBox
                title={label}
                stat={metrics[key]}
                description={descriptions[key]}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  );
}
